import React from "react";
import bg from "../assets/img/bg-main.png";
import tgIcon from '../assets/img/tg.svg'
import appleIcon from '../assets/img/apple-icon.svg'
import googleIcon from '../assets/img/google-icon.svg'
import coinsBg from '../assets/img/coins-img.png'
import boxBg from '../assets/img/box-img.png' 


export const SpecialOfferAuth = () => {
  return (
    <div id="special-offer-auth">
      <div className="special-bg">
        <img src={bg} alt="bg-img" />
      </div>
      <div className="container">
        <div className="special-offer-auth">
          <div className="left-content">
                <div className="content-txt">
                    <h1>Спецпредложение 0 комиссий на все оптовые пары</h1>
                    <div className="big-grey">
                        Фьючерсы: 0% мейкер, 0,02% тейкер
                    </div>
                </div>
                <div className="content-register">
                    <div className="register-field">
                        <input type="text" placeholder="Эл.почта/номер телефона" className="inp-register"/>
                        <button className="btn-content register">Регистрация</button>
                    </div>
                    <div className="login-ways">
                        <div className="icon">
                            <img src={tgIcon} alt="tg-icon" />
                        </div>
                        <div className="icon">
                            <img src={appleIcon} alt="apple-icon" />
                        </div>
                        <div className="icon">
                            <img src={googleIcon} alt="google-icon" />
                        </div>
                    </div>
                </div>
          </div>
          <div className="right-content">
            <div className="coins-bg">
                <img src={coinsBg} alt=""/> 
            </div>
            <div className="box-bg">
                <img src={boxBg} alt=""/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
